<template>
  <StatusDialog
    :visible.sync="dialogVisible"
    type="warning"
    :width="500"
    class="account-trial-limit-dialog"
    @close="onClose"
  >
    <p class="status-dialog__desc account-trial-limit-dialog__desc">
      当前为试用账户，购买服务后可继续新增账户
    </p>
    <div class="status-dialog__footer">
      <button
        type="button"
        class="status-dialog__btn status-dialog__btn--purchase"
        @click="onPurchase"
      >
        购买服务
      </button>
    </div>
  </StatusDialog>
</template>

<script>
import StatusDialog from "@/components/statusDialog";

const TRIAL_ACCOUNT_LIMIT_MSG = "您的直连账户已达数量上限，暂无法新增";

/** 添加账户时是否为试用达上限（code=400） */
export function isTrialAccountLimitError(res, isAdd) {
  if (!isAdd || !res || !res.data) return false;
  const msg = String(res.data.message || res.data.msg || "").trim();
  return Number(res.data.code) === 400 && msg === TRIAL_ACCOUNT_LIMIT_MSG;
}

/** 试用账户达新增上限时的引导弹窗（CTP / 第三方添加共用） */
export default {
  name: "AccountTrialLimitDialog",
  components: { StatusDialog },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    onClose() {
      this.dialogVisible = false;
    },
    onPurchase() {
      this.dialogVisible = false;
      this.$emit("purchase");
    },
  },
};
</script>

<style scoped>
/* 叠在添加账户 FormDialog（z-index 1000）之上 */
.account-trial-limit-dialog {
  z-index: 1100 !important;
}

.account-trial-limit-dialog__desc {
  margin-bottom: 28px;
}
</style>



// WEBPACK FOOTER //
// src/view/user/eval_jees/AccountTrialLimitDialog.vue